import { Button } from '@mui/material';
import { identity } from 'fp-ts/function';
import { jsx as _jsx } from "react/jsx-runtime";
export var error = function error(t) {
  return {
    message: t('Sorry there was a problem while sharing. Try again later.'),
    severity: 'error',
    duration: 'medium'
  };
};
export var success = function success(message, t) {
  return {
    message: t(message),
    severity: 'success',
    duration: 'medium'
  };
};
export var authExpiredError = function authExpiredError(provider, reconnect, t) {
  return {
    severity: 'error',
    message: t("Your post couldn't be shared because your {{provider}} connection has expired.", {
      provider: provider
    }),
    duration: 'medium',
    action: /*#__PURE__*/_jsx(Button, {
      color: "inherit",
      size: "small",
      onClick: reconnect,
      children: t('Reconnect')
    })
  };
};
export var unconnectedError = function unconnectedError(provider, connect, t) {
  return {
    severity: 'error',
    message: t("Looks like your {{provider}} account isn't connected.", {
      provider: provider
    }),
    duration: 'medium',
    action: /*#__PURE__*/_jsx(Button, {
      color: "inherit",
      size: "small",
      onClick: connect,
      children: t('Connect {{provider}}', {
        provider: provider
      })
    })
  };
};
export var textCopied = function textCopied(t) {
  return identity({
    message: t('The default share text has been copied to your clipboard. Paste it in to share'),
    severity: 'info',
    duration: 'medium',
    sx: {
      background: function background(t) {
        return t.palette.other.snackbar;
      },
      color: function color(t) {
        return t.palette.primary.contrastText;
      }
    },
    icon: false,
    closeSx: {
      fill: function fill(t) {
        return t.palette.primary.contrastText;
      }
    }
  });
};